export const CONTRACT_TYPES = {
	SB: "Salary Based",
	HR: "Hourly Rate"
};
